/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

'use strict';

module.exports = require('react-dom');


//////////////////
// WEBPACK FOOTER
// ./~/fixed-data-table/internal/ReactDOM.js
// module id = 1270
// module chunks = 0